import { render, staticRenderFns } from "./schemeShar.vue?vue&type=template&id=354fa612&scoped=true"
import script from "./schemeShar.vue?vue&type=script&lang=js"
export * from "./schemeShar.vue?vue&type=script&lang=js"
import style0 from "./schemeShar.vue?vue&type=style&index=0&id=354fa612&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fa612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354fa612')) {
      api.createRecord('354fa612', component.options)
    } else {
      api.reload('354fa612', component.options)
    }
    module.hot.accept("./schemeShar.vue?vue&type=template&id=354fa612&scoped=true", function () {
      api.rerender('354fa612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/trip/schemeShar.vue"
export default component.exports